import type { RouteLocationNormalized } from 'vue-router'

import { ArchivedStatus, ReadStatus } from '@/gql/platform-api'
import { checkEnumValue } from '@/helpers/checkEnumValue'

export enum NotificationCenterTab {
  ALL = 'all',
  UNREAD = 'unread',
  ARCHIVED = 'archived',
}

export const notificationCenterTabFromQuery = (query: RouteLocationNormalized['query']): NotificationCenterTab =>
  checkEnumValue(query.tab, NotificationCenterTab, NotificationCenterTab.ALL)

export const tabToQueryArgs = (tab: NotificationCenterTab): { readStatus: ReadStatus; archivedStatus: ArchivedStatus } => {
  switch (tab) {
    case NotificationCenterTab.UNREAD:
      return { readStatus: ReadStatus.Unread, archivedStatus: ArchivedStatus.Visible }
    case NotificationCenterTab.ARCHIVED:
      return { readStatus: ReadStatus.All, archivedStatus: ArchivedStatus.Archived }
    default:
      return { readStatus: ReadStatus.All, archivedStatus: ArchivedStatus.Visible }
  }
}
